







































































import Vue from "vue";
import { $eventsBus } from "@/main";
import { Item } from "../models/classes/Item";
import BaseInput from "@/app/shared/components/base/BaseInput.vue";

export default Vue.extend({
  name: "Dropzone",
  components: {
    BaseInput,
  },
  data: function () {
    return {
      hightlight: false,
      enabled: true,
      inputURLString: "",
      loadingLink: false,
    };
  },
  props: {
    topHeightShift: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    items: function () {
      return this.$store.state.items;
    },
    previewItem: function () {
      return this.$store.state.selectedItem;
    },
    userWorkParameters: function () {
      return this.$store.state.userWorkParameters;
    },
    filesToUpload: {
      get: function () {
        return this.$store.state.filesToUpload;
      },
      set: function (filesToUpload) {
        this.$store.commit("updateFilesToUpload", filesToUpload);
      },
    },
  },
  methods: {
    //Dropzone
    openFileSelection(): void {
      if (!this.$data.enabled) return;
      (<HTMLElement>this.$refs.fileInput).click();
    },
    onDragOver(event: DragEvent): void {
      if (!this.$data.enabled) return;
      event.preventDefault();
      this.$data.hightlight = true;
    },
    onDragLeave(event: DragEvent): void {
      //TODO
      if (
        event.target &&
        (<HTMLElement>event.target).className.includes("dropzone-container") &&
        event.relatedTarget &&
        ((<HTMLElement>event.relatedTarget).className.includes(
          "dropzone-container"
        ) ||
          (<HTMLElement>event.relatedTarget).className.includes("side-menu"))
      ) {
        return;
      }

      this.$data.hightlight = false;
    },
    async getFileFromFileEntry(fileEntry): Promise<any> {
      try {
        return await new Promise((resolve, reject) =>
          fileEntry.file(resolve, reject)
        );
      } catch (err) {
        console.log(err);
        return null;
      }
    },
    async parseDropedQueue(entry, filesToUpdate) {
      const getFileFromFileEntry = this.getFileFromFileEntry;
      const parseDropedQueue = this.parseDropedQueue;
      if (entry.isDirectory) {
        await new Promise<void>((resolve) =>
          entry.createReader().readEntries(async function (entries) {
            await Promise.all(
              entries.map(async (ent) => {
                if (ent.isDirectory) {
                  //WARNING recursion!
                  await parseDropedQueue(ent, filesToUpdate);
                } else if (ent.isFile) {
                  let file = await getFileFromFileEntry(ent);
                  filesToUpdate.push(file);
                }
                return true;
              })
            ).then(() => {
              resolve();
            });
          })
        );
      } else {
        let file = await getFileFromFileEntry(entry);
        filesToUpdate.push(file);
      }
      return true;
    },
    async onDrop(event: DragEvent): Promise<void> {
      if (!this.$data.enabled) return;
      event.preventDefault();
      const files = event.dataTransfer.files;
      let filesToUpload = Object.entries(files).map((f) => f[1]);
      if (filesToUpload.some((f) => f.type === "")) {
        filesToUpload = [];

        //TODO refactor promises
        await Promise.all(
          Object.entries(event.dataTransfer.items)
            .map((d) => d[1])
            .map(async (dataTransferItem) => {
              let entry = dataTransferItem.webkitGetAsEntry();
              await this.parseDropedQueue(entry, filesToUpload);
            })
        );
      }
      this.validateAndUploadFiles(filesToUpload, 1);
    },

    onFileChanged(event: any) {
      let files: FileList = event.target.files;
      this.validateAndUploadFiles(
        Object.entries(files).map((f) => f[1]),
        2
      );
      event.target.value = "";
    },
    validateAndUploadFiles(files: File[], uploadedTypeId): void {
      let maxCount = 30;
      maxCount = files.length > maxCount ? maxCount : files.length;
      this.uploadDropFiles(files.slice(0, maxCount), uploadedTypeId);
    },
    uploadDropFiles(files: File[], uploadedTypeId: number): void {
      //let uploadingId = `f${(~~(Math.random() * 1e8)).toString(16)}`;
      let filesToUpload = [];
      files.forEach((f) => {
        let uploadingId = `f${(~~(Math.random() * 1e8)).toString(16)}`;
        filesToUpload.push({
          uploadingId: uploadingId,
          file: f,
        });
      });
      this.$data.hightlight = false;
      console.log(filesToUpload);
      if (filesToUpload && filesToUpload.length) {
        let correctFilesToUpload = this.getCorrectFiles(filesToUpload);

        correctFilesToUpload.reduce((promiseChain, fileToUpload) => {
          return promiseChain.then(
            () =>
              new Promise((resolve) => {
                this.checkAndGetFileData(
                  fileToUpload.file,
                  (videoFileParameters, resolve) => {
                    this.uploadFiles([fileToUpload]);
                    if (
                      videoFileParameters.videoWidth === 1920 &&
                      videoFileParameters.videoHeight === 1920 &&
                      (this.userWorkParameters.enableSlicerByDefault === null ||
                        this.userWorkParameters.enableSlicerByDefault ===
                          undefined)
                    ) {
                      this.userWorkParameters.enableSlicerByDefault = true;
                      $eventsBus.$emit("openConfirmWindow", {
                        isInline: true,
                        message: "Slicer mode enables automatically.",
                        acceptTitle: "Set as default",
                        discardTitle: "Disable",
                        acceptCallback: () => {},
                        discardCallback: (() => {
                          this.userWorkParameters.enableSlicerByDefault = false;
                          this.items.forEach((item) => {
                            item.switchSlicerMode(false);
                          });
                        }).bind(this),
                      });
                    }
                    let newItem = Item.createNewItemByFile(
                      fileToUpload.file,
                      videoFileParameters,
                      fileToUpload.uploadingId,
                      uploadedTypeId,
                      !!this.userWorkParameters.enableSlicerByDefault
                    );
                    if (newItem.isForSlice) {
                      Item.videoSizes.forEach((size) =>
                        newItem.addNewVariation(
                          this.$store.state.userInfo.isSaveOriginalName,
                          JSON.parse(
                            JSON.stringify(
                              this.$store.state.variationNamingTemplate
                            )
                          ),
                          size.name
                        )
                      );
                    } else {
                      newItem.addNewVariation(
                        this.$store.state.userInfo.isSaveOriginalName,
                        JSON.parse(
                          JSON.stringify(
                            this.$store.state.variationNamingTemplate
                          )
                        )
                      );
                    }
                    this.items.push(newItem);
                    if (!this.previewItem) {
                      this.$store.commit("changeSelectItem", this.items[0]);
                    }
                    resolve();
                  },
                  (resolve) => {
                    this.filesToUpload.push(fileToUpload);
                    this.uploadFiles([fileToUpload]);
                    resolve();
                  },
                  resolve
                );
              })
          );
        }, Promise.resolve());
      }
    },
    //Files uploading
    getCorrectFiles(filesToUpload): any[] {
      const maxFileSize = 1 * 1024 * 1024 * 1024;
      return filesToUpload.filter((f) => {
        if (f.file.size > maxFileSize) {
          console.log("error");
          return false;
        } else {
          return true;
        }
      });
    },
    uploadFiles(files): void {
      if (files.length === 0) {
        return;
      }
      const uploadProgress = (uploadingId) => (progressEvent) => {
        let percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        let item = this.items.find(
          (i) => i.loadingParameters.uploadingId === uploadingId
        );
        if (!!item) {
          item.loadingParameters.process = percentCompleted;
        }
        console.log(percentCompleted);
      };
      const config = {
        onUploadProgress: uploadProgress(files[0].uploadingId).bind(this),
        ///cancelToken: this.$axiosCancelTokenSource.token,
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
      };

      for (var i = 0; i < files.length; i++) {
        let fileItem = files[i];
        let data = new FormData();
        data.append("files[0]", fileItem.file);
        data.append("sessionId", this.$store.state.userInfo.sessionId);

        let route = "/uploads/uploadMediaFiles";
        let uploadingId = fileItem.uploadingId;

        this.axios
          .post(route, data, config)
          .then((res) => {
            console.log(res);
            this.checkAndLoadFiles(res.data, uploadingId);
          })
          .catch((err) => {
            if ((<string>err.toString()).toLowerCase().includes("cancel")) {
              console.info("File uploading request canceled");
            } else {
              console.log(err);
            }
          });
      }
    },
    checkAndGetFileData(file, dataCallback, badFileDataCallback, resolve) {
      let fileType = file.type;
      console.log("type", fileType);
      if (fileType.indexOf("video") == -1) {
        badFileDataCallback(resolve);
        return;
      }
      let fileSrc = window.URL.createObjectURL(file);
      let videoEl: HTMLVideoElement = document.createElement("video");
      videoEl.style.display = "none";
      document.body.append(videoEl);
      videoEl.src = fileSrc;

      let videoTagRef = videoEl;
      let hasVideoMetadata = false;
      videoTagRef.addEventListener("loadedmetadata", function (e) {
        if (hasVideoMetadata) {
          return;
        }
        hasVideoMetadata = true;
        if (
          !!videoTagRef.duration &&
          !!videoTagRef.videoWidth &&
          !!videoTagRef.videoHeight
        ) {
          dataCallback(
            {
              duration: Math.round(videoTagRef.duration * 1000) / 1000,
              videoWidth: videoTagRef.videoWidth,
              videoHeight: videoTagRef.videoHeight,
            },
            resolve
          );
        } else {
          badFileDataCallback(resolve);
        }
        videoEl.remove();
      });
      setTimeout(() => {
        if (!hasVideoMetadata) {
          hasVideoMetadata = true;
          videoEl.remove();
          badFileDataCallback(resolve);
        }
      }, 500);
    },
    checkAndLoadFiles(data, uploadingId): void {
      let indexesToDelete = [];
      let lastErrorText = "";
      let files = data;
      files.forEach((uploadedFile) => {
        if (!uploadedFile.success) {
          var invalidFileIndex = files.indexOf(uploadedFile);
          indexesToDelete.push(invalidFileIndex);
          var errorText = uploadedFile.error;
          console.error(
            "File upload error " + uploadedFile.name + ": " + errorText
          );
          lastErrorText = errorText;
        }
      });
      let allCount = files.length;
      indexesToDelete.sort((a, b) => b - a).forEach((i) => files.splice(i, 1));

      if (files.length === 0) {
        if (allCount > 1) {
          console.log("All files upload error");
        } else {
          console.log(lastErrorText);
        }
        //TODO
      } else {
        console.log(
          "Upload complete!" +
            (indexesToDelete.length > 0
              ? " Errors: " + indexesToDelete.length + "/" + allCount
              : "")
        );
        this.itemsUploaded(files, uploadingId);
      }
      this.filesToUpload = this.filesToUpload.filter(
        (fileItem) => fileItem.uploadingId !== uploadingId
      );
    },
    stopInputURLString() {
      if (this.inputURLString === "") {
        return;
      }
      this.loadingLink = true;

      // https://www.youtube.com/watch?v=Gh3l2Zd-uw0
      // https://youtu.be/Gh3l2Zd-uw0
      console.group('Пробуем')

      let youTubeWatchUrlPattern = /watch/
      let youTubeValideUrlPattern = /youtu.be/
      let yandexValideUrlPattern = /disk.yandex.ru/

      if (youTubeWatchUrlPattern.test(this.inputURLString)) {
        window.alert('Введена ссылка на просмотр youtube. Введите ссылку формата https://youtu.be/...')
        return
      }

      if (youTubeValideUrlPattern.test(this.inputURLString)) {
        console.log('Верная ссылка youtube')
        this.axios
          .post(
            "YoutubeUpload",
            {
              sessionId: this.$store.state.userInfo.sessionId,
              link: this.inputURLString,
            },
            {
              headers: {
                Accept: "*/*",
                "Content-Type": "application/json",
              },
            }
          )
          .then((res) => {
            const filesToImport = [];

            res.data.forEach((fileObject) => {
              filesToImport.push(fileObject);
            });

            if (filesToImport.length !== 0) {
              this.$store.commit("itemsUploaded", filesToImport);
              $eventsBus.$emit("saveUserWorkspace", true);
              this.$store.commit("addNewStateToHistory");
            }
          })
          .catch((err) => {
            console.log(err);
            alert("Error upload from URL!");
          })
          .finally(() => {
            this.inputURLString = "";
            this.loadingLink = false;
          });
        return
      }

      if (yandexValideUrlPattern.test(this.inputURLString)) {
        console.log('Валидная ссылка яндекс')

        this.axios
          .post(
            "/uploads/YandexUpload",
            {
              sessionId: this.$store.state.userInfo.sessionId,
              link: this.inputURLString,
            },
            {
              headers: {
                Accept: "*/*",
                "Content-Type": "application/json",
              },
            }
          )
          .then((res) => {
            const filesToImport = [];

            res.data.forEach((fileObject) => {
              filesToImport.push(fileObject);
            });

            if (filesToImport.length !== 0) {
              this.$store.commit("itemsUploaded", filesToImport);
              $eventsBus.$emit("saveUserWorkspace", true);
              this.$store.commit("addNewStateToHistory");
            }
          })
          .catch((err) => {
            console.log(err);
            alert("Error upload from URL!");
          })
          .finally(() => {
            this.inputURLString = "";
            this.loadingLink = false;
          });
        return
      }



      console.groupEnd()

    },
    itemsUploaded(data, uploadingId): void {
      let item = this.items.find(
        (i) => i.loadingParameters.uploadingId === uploadingId
      );
      if (!!item) {
        this.$store.commit("updateItemsAfterUpload", {
          uploadingId: uploadingId,
          files: data,
        });
      } else {
        this.$store.commit("itemsUploaded", data);
      }

      $eventsBus.$emit("saveUserWorkspace", true);
      this.$store.commit("addNewStateToHistory");

      data.forEach((file) => {
        //TODO test yandex metrik
        try {
          if (this.$metrika) {
            this.$metrika.reachGoal("upload_video");
          }
        } catch (e) {
          console.error(e);
        }
      });
    },
  },
});
